/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

var headMenuDefaultProps = {
  expandType: "normal",
  theme: "light"
};
var menuDefaultProps = {
  collapsed: false,
  expandMutex: false,
  expandType: "normal",
  theme: "light",
  width: "232px"
};
var menuGroupDefaultProps = {};
var menuItemDefaultProps = {};
var submenuDefaultProps = {};

export { headMenuDefaultProps, menuDefaultProps, menuGroupDefaultProps, menuItemDefaultProps, submenuDefaultProps };
//# sourceMappingURL=defaultProps.js.map
